module.exports = "type Query {\n  getUser(id: String!): User\n  searchUser(name: String!): [User!]!\n}\n\ntype Mutation {\n  deleteUser(id: String!): Null\n}\n\ntype User {\n  name: Name\n  email: String\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!../examples/graphql-server/src/graphql/schema/User/User.graphql
// module id = 668
// module chunks = 249879837935775